module.exports = __webpack_public_path__ + "static/unbreakable-zack-collie-718e8374bf6fec73a5443370cfd4c689.jpg";